import { api } from "@/api/axios.ts";
import { ApiCalendar } from "@/types/calendar.types.ts";

export const apiCalendars = {
  getAll: () => {
    return api.get<ApiCalendar[]>(`/api/v1/calendars`);
  },
};
